import gql from 'graphql-tag';

// This is used in GlobalNav
export const markNotificationRead = gql`
  mutation markNotificationRead($associateId: String!) {
    markNotificationRead(associateId: $associateId) {
      associateId
      notificationCount
    }
  }
`;

// This is used in Conversation pages
export const markAllMessagesRead = gql`
  mutation markAllMessagesRead($associateId: String!, $messageIdList: [String!]!, $contactId: String!) {
    markAllMessagesRead(associateId: $associateId, messageIdList: $messageIdList, contactId: $contactId) {
      associateId
      contactId
      notificationCount
    }
  }
`;

// This is used for creating a message
export const createMessageOneToManyInboxAndConversation = gql`
  mutation createMessageOneToManyInboxAndConversation(
    $messageId: String!
    $associateId: String!
    $contactId: [String!]!
    $message: String
    $message_subject: String
    $date_created: String
    $message_direction: String!
    $message_type: String!
  ) {
    createMessageOneToManyInboxAndConversation(
      associateId: $associateId
      messageId: $messageId
      contactId: $contactId
      message: $message
      message_subject: $message_subject
      date_created: $date_created
      message_direction: $message_direction
      message_type: $message_type
    ) {
      messageId
      associateId
      contactId
      message_direction
      message
      message_status
      message_type
      message_subject
      date_created
    }
  }
`;

// This is used in notifications
export const updateEventStatus = gql`
  mutation updateEventStatus($associateId: String!, $eventId: [String!]!, $event_status: String!) {
    updateEventStatus(associateId: $associateId, eventId: $eventId, event_status: $event_status) {
      eventId
      associateId
      event_status
      type
      description
      timestamp
      customerName
      message
      customerId
    }
  }
`;

// This is not used anywhere atm
export const createNotificationCount = gql`
  mutation createNotificationCount($associateId: String!) {
    createNotificationCount(associateId: $associateId) {
      associateId
      notificationCount
    }
  }
`;

// This is not used anywhere atm
export const createMessageInboxAndConversation = gql`
  mutation createMessageInboxAndConversation(
    $messageId: String!
    $associateId: String!
    $contactId: String!
    $message: String
    $message_subject: String
    $date_created: String
    $message_direction: String!
    $message_type: String!
  ) {
    createMessageInboxAndConversation(
      associateId: $associateId
      messageId: $messageId
      contactId: $contactId
      message: $message
      message_subject: $message_subject
      date_created: $date_created
      message_direction: $message_direction
      message_type: $message_type
    ) {
      messageId
      associateId
      contactId
      message_direction
      message
      message_status
      message_type
      message_subject
      date_created
    }
  }
`;

// This is not used anywhere atm
export const updateNotificationCount = gql`
  mutation updateNotificationCount($associateId: String!) {
    updateNotificationCount(associateId: $associateId) {
      associateId
      notificationCount
    }
  }
`;

// This is not used anywhere atm
export const createMessageNotification = gql`
  mutation createMessageNotification(
    $associateId: String!
    $contactId: String!
    $contactName: String
    $last_message: String!
    $message_type: String!
    $last_date_created: String
  ) {
    createMessageNotification(
      associateId: $associateId
      contactId: $contactId
      contactName: $contactName
      last_message: $last_message
      message_type: $message_type
      last_date_created: $last_date_created
    ) {
      associateId
      contactId
      contactName
      notificationCount
      message_inbox_status
      last_message
      message_type
      message_subject
      last_date_created
    }
  }
`;

// This is not used anywhere atm
export const updateMessageNotificationCount = gql`
  mutation updateMessageNotificationCount(
    $associateId: String!
    $contactId: String!
    $last_message: String!
    $message_subject: String
    $last_date_created: String
  ) {
    updateMessageNotificationCount(
      associateId: $associateId
      contactId: $contactId
      last_message: $last_message
      message_subject: $message_subject
      last_date_created: $last_date_created
    ) {
      associateId
      contactId
      contactName
      notificationCount
      message_inbox_status
      last_message
      message_type
      message_subject
      last_date_created
    }
  }
`;

// This is not used anywhere atm
export const createMessage = gql`
  mutation createMessage(
    $messageId: String!
    $associateId: String!
    $contactId: String!
    $message_direction: String!
    $message: String
    $message_status: String
    $message_type: String!
    $message_subject: String
    $date_created: String
  ) {
    createMessage(
      messageId: $messageId
      associateId: $associateId
      contactId: $contactId
      message_direction: $message_direction
      message: $message
      message_status: $message_status
      message_type: $message_type
      message_subject: $message_subject
      date_created: $date_created
    ) {
      associateId
      contactId
      messageId
      message_direction
      message
      message_status
      message_type
      message_subject
      date_created
    }
  }
`;

// This is not used anywhere atm
export const updateMessageStatus = gql`
  mutation updateMessageStatus(
    $messageId: String!
    $associateId: String!
    $contactId: String!
    $message_direction: String!
    $message_status: String!
    $date_created: String
  ) {
    updateMessageStatus(
      messageId: $messageId
      associateId: $associateId
      contactId: $contactId
      message_direction: $message_direction
      message_status: $message_status
      date_created: $date_created
    ) {
      associateId
      contactId
      messageId
      message_direction
      message_status
      date_created
    }
  }
`;

// This is not used anywhere atm
export const markMessageStatusRead = gql`
  mutation markMessageStatusRead(
    $messageId: String!
    $associateId: String!
    $contactId: String!
    $message_direction: String!
    $message_status: String!
    $date_created: String
  ) {
    markMessageStatusRead(
      messageId: $messageId
      associateId: $associateId
      contactId: $contactId
      message_direction: $message_direction
      message_status: $message_status
      date_created: $date_created
    ) {
      associateId
      contactId
      messageId
      message_direction
      message_status
      date_created
    }
  }
`;

// This is not used anywhere atm
export const markMessageNotificationRead = gql`
  mutation markMessageNotificationRead($associateId: String!, $contactId: String!) {
    markMessageNotificationRead(associateId: $associateId, contactId: $contactId) {
      associateId
      contactId
      notificationCount
    }
  }
`;

// This is not used anywhere atm
export const createEvent = gql`
  mutation createEvent($associateId: String!, $type: String!, $description: String!, $customerName: String!) {
    createEvent(associateId: $associateId, type: $type, description: $description, customerName: $customerName) {
      eventId
      associateId
      event_status
      type
      description
      timestamp
      customerName
    }
  }
`;
